import { Link } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormBannerContent } from "context/formBanner/FormBannerContext";
import PPMVSurvey from "./PPMVSurvey";
import Thankyou from "components/mis-survey/sections/thank-you/Thankyou";

const WelcomePPMV = () => {
	const { dispatch, surveyBanner } = useFormBannerContent();

	const headingSpring = useSpring({
		from: { transform: "translateY(-50px)", opacity: 0 },
		to: { transform: "translateY(0)", opacity: 1 },
		config: { tension: 100, friction: 30 },
	});

	const contentSpring = useSpring({
		from: { transform: "translateY(50px)", opacity: 0 },
		to: { transform: "translateY(0)", opacity: 1 },
		config: { tension: 100, friction: 30 },
		delay: 300,
	});

	const proceedToSurvey = () => {
		dispatch({
			type: "UPDATE",
			payload: {
				title: "Business Information",
				subTitle: "We would love to know a bit about you.",
				description: `Please provide your information to help us
                    understand better.`,
				backgroundImageUrl:
					"bg-[url('/public/images/ppmv/welcome-bg.jpg')]",
				formCompletedAt: null,
				screen: "PPMV_QUESTIONS",
			},
		});
	};

	console.log({ surveyBanner });

	return (
		<>
			{surveyBanner?.screen !== "PPMV_QUESTIONS" &&
				surveyBanner?.screen !== "THANK_YOU" && (
					<section className="relative bg-welcome-bg bg-center bg-cover">
						<Backdrop
							sx={(theme) => ({
								color: "#fff",
								zIndex: theme.zIndex.drawer + 3,
							})}
							open={false}
						>
							<CircularProgress color="inherit" />
						</Backdrop>
						<div className="absolute inset-0 bg-gradient-to-r from-black/85 to-transparent z-0"></div>
						<header className="text-primary relative z-10 p-3">
							<img src="/sproxillogo.png" alt="Sproxil Logo" />
						</header>

						<section className="relative z-10 min-h-[calc(100dvh-59px)] max-w-3xl flex flex-col items-center justify-center mx-auto text-center px-3 text-white">
							<div className="bg-stone-black/50 min-h-fit py-5 px-3 rounded-lg text-white">
								<animated.h1
									style={headingSpring}
									className="text-4xl font-medium mb-4"
								>
									Welcome to Sproxil PPMV Survey
								</animated.h1>

								<animated.div style={contentSpring}>
									<p className="mb-5">
										We aim to understand how PPMVs support
										mothers and newborns to improve health
										services. 👩‍👶 Your feedback will help
										us identify strengths, areas for
										improvement, and ways to enhance care.
										💕
									</p>
									<p className="mb-5">
										All responses are confidential 🔒 and
										will only be used to improve health
										services in accordance with our{" "}
										<Link
											to={
												"https://sproxil.com/terms-of-service/"
											}
											target="_blank"
											className="text-primary-light underline font-medium hover:text-primary active:text-primary"
										>
											Terms of Service.
										</Link>{" "}
										<br />
										Thank you for your time and valuable
										input! 🙏✨
									</p>

									<button
										onClick={proceedToSurvey}
										className="primary-btn block mx-auto disabled:brightness-50"
									>
										proceed
									</button>
								</animated.div>
							</div>
							<section className="flex items-center justify-center relative z-50 w-full mt-6 gap-5 flex-wrap">
								<div className="flex items-center gap-5">
									<img
										src="/images/ppmv/kano-logo.png"
										alt="Sproxil Logo"
										className="w-20 h-20"
									/>
									<img
										src="/images/ppmv/kaduna-logo.png"
										alt="Sproxil Logo"
										className="w-20 h-20"
									/>
								</div>
								<div className="flex items-center gap-5">
									<img
										src="/images/ppmv/kano-man.jpeg"
										alt=""
										className="w-24 h-24"
									/>
									<img
										src="/images/ppmv/kaduna-man.jpeg"
										alt=""
										className="w-24 h-24"
									/>
								</div>
							</section>
						</section>
					</section>
				)}

			{surveyBanner?.screen === "PPMV_QUESTIONS" && <PPMVSurvey />}

			{surveyBanner?.screen === "THANK_YOU" && <Thankyou />}
		</>
	);
};

export default WelcomePPMV;
